<template>
  <div class="network-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'phone-table' }">
          Phone Table
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
        :model="formData"
        status-icon
        :rules="rulesValidate"
        ref="tinderAccountEditForm"
        label-width="135px"
        class="demo-ruleForm"
      >

      <el-form-item label="Phone ID" prop="phone_id">
        <el-input
          type="text"
          v-model="formData.phone_id"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="Status" prop="status">
        <el-input
          type="text"
          v-model="formData.status"
          autocomplete="off"
        ></el-input>
      </el-form-item>    

      <el-form-item label="Phone" prop="phone">
        <el-input
          type="text"
          v-model="formData.phone"
          autocomplete="off"
        ></el-input>
      </el-form-item> 
      
      <el-form-item label="Proxy" prop="proxy">
        <el-select
          v-model="formData.proxy_address"
          multiple
          collapse-tags
          placeholder="Select phone IDs"
        >
          <el-option
            v-for="item in proxyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>  
      
      <el-form-item label="Tinder ID" prop="tinder_id">
        <el-input
          type="text"
          v-model="formData.tinder_id"
          autocomplete="off"
        ></el-input>
      </el-form-item>   
      
     
      <el-form-item label="City" prop="city">
        <el-input
          type="text"
          v-model="formData.city"
          autocomplete="off"
        ></el-input>
      </el-form-item>       

   
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('tinderAccountEditForm')"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapGetters } from 'vuex'

let mobileValidate = (rule, value, callback) => {
  let mobReg = /^\d{11,13}$/;
  if(!mobReg.test(value)){
    callback(new Error('Invalid phone number.'));
  }else{
    callback();
  }
}

export default {
  name: 'PhoneTableEdit',
  data() {
    return {
      // customDropdownClass: 'your-custom-class',
      // customDropdownClass: 'your-custom-class',
      formData: {
        phone_id: 'test',
        status: 'test',
        phone: 'test',
        proxy_address: 'test',
        tinder_id: 'test',
        city: 'test',

        account_group_id: null,
        phone_paid_id: null,
        phone_paid: {
          city: null, 
          id: null, 
          ip: null
        },
        phone_provider_id: null,
        country_code_id: 6,
        session_expired: null,
        web_uuid: null,
        user_agent: null,
        api_token: '',
        email: "testemail",
        blocked: true,
        autoscan: false,
        notes: "",
      },


      proxyOptions: [
        { value: 'test1', label: 'Test 1' },
        { value: 'test2', label: 'Test 2' },
        { value: 'test3', label: 'Test 3' },
        { value: 'test4', label: 'Test 4' },
        { value: 'test5', label: 'Test 5' },
        { value: 'test6', label: 'Test 6' },
      ],          


      preparedSmsHistory: "",
      rulesValidate: {
          account_group_id: [{required: true, message: 'Choose Group', trigger: 'blur'}],
          phone_paid_id: [
            {
              required: () => !this.formData.phone_paid_id,
              message: 'Please choose the phone IP',
              trigger: 'blur'
            }
          ],
          phone_provider_id: [{required: true, message: 'Please choose the phone Provider', trigger: 'blur'}],
          status: [{required: true, message: 'Please choose the Status', trigger: 'blur'}],
          country_code_id: [{required: true, message: 'Please choose the phone country', trigger: 'blur'}],
          session_expired: [{required: true, message: 'Please choose the expired date', trigger: 'blur'}],
      },
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.handleDisabledDate
      },
      statusOptions: [
        {
          value: 1,
          label: 'blocked',
          text: 'Blocked'

        },
        {
          value: 2,
          label: 'active',
          text: 'Active'
        },
        {
          value: 3,
          label: 'verification',
          text: 'Verification'
        }
      ],
      showByStatus: 1,       
    }
  },
  computed: {
    ...mapGetters({
      tinderAccountData: 'tinderAccounts/showTinderAccount',
      paidProxies: 'tinderAccounts/getPaidProxies',
      phoneProviders: 'tinderAccounts/getPhoneProviders',
      tinderAccountGroups: 'tinderAccounts/getTinderAccountGroups',
      countries: 'tinderAccounts/getCountries'
    }),
  },
  watch: {
  
  },
  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('tinderAccounts/showTinderAccount', this.$route.params.id)
        .then(() => {
          if (this.tinderAccountData.phone_paid && this.tinderAccountData.phone_paid.id) {
            this.$nextTick(() => {
              this.$set(this.formData, 'phone_paid_id', this.tinderAccountData.phone_paid.id);
            });
          }
        });
    } else {
      this.$store.dispatch('tinderAccounts/clearCurrentTinderAccount');
    }
    this.$store.dispatch('tinderAccounts/getPaidProxies')
    this.$store.dispatch('tinderAccounts/getPhoneProviders')
    this.$store.dispatch('tinderAccounts/getTinderAccountGroups')
    this.$store.dispatch('tinderAccounts/getCountries')

    let copy = {...this.formData, ...this.tinderAccountData}
    this.formData = copy
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.$route.params.id) {
            this.$store.dispatch('tinderAccounts/createTinderAccount', this.formData)
            .then(response => {
                this.$notify.success('Account has been added')
                this.$router.push({name:"tinder-accounts"})
            })
            .catch(error => {
                console.log('error',error);
            })
          } else {
            this.$store.dispatch('tinderAccounts/updateTinderAccount', this.formData)
          }
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          return false
        }
      })
    },
    handleDisabledDate(date) {
      return date <= new Date()
    },
    prepareSmsHistory(history){
      let result = '';
      history.forEach(function(item, i, arr) {
        result += 'Date: '+item.created_at+' Content: '+item.content+";\n";
      });
      return result;
    },
    updatePhonePaidId(value) {
      this.$set(this.formData, 'phone_paid_id', value);
    },    
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 15px;
}
.el-input {
  max-width: 600px;
}
.el-input__inner {
  width: 100px !important;
}
.el-textarea {
  max-width: 600px;
}
.phone-select {
  height: 50px;
  border-bottom: solid 1px #80808026;
  padding: 0 20px 0 10px;
  &-dropdown {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;    
  }
  &-city {
    display: flex;
    flex-direction: column;
    span {
      display: block;
      margin: -5px 0px;
    }    
  }    
}

.row-block {
  max-width: 735px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 1030px) {
    flex-direction: column;
  }
}
.country-code-with-phone {
  display: flex;
  flex-direction: row;
}
.sms-input {
  min-width: 70px !important;
}

.custom-phone-input {
  margin-left: -135px;
  width: 305px;
  @media screen and (max-width: 1030px) {
    width: 86%;
  }   
}
.custom-select-group {
  width: 98px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-select-created {
  width: 142px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-select-expired, .custom-request-count, .custom-select-phone, .custom-select-status {
  width: 250px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-radio-autoscan {
    margin-left: 10px;
    @media screen and (max-width: 1030px) {
      margin-left: 0;
    }      
}
</style>
